import React from 'react';

import { makeStyles } from '@material-ui/core';
import {
    Link, getCiaFromUrl, 
    // PortalContext,
     esGestiona
} from '@portal/arq-portal-core';

import datos from '../utils/datos.json';

const useStyles = makeStyles({
    footerContainer: {
        backgroundColor: '#5d5d5d',
        padding: '10px 25px',
        display: 'flex',
        flexDirection: 'column',
        fontSize: 12
    },
    enlace: {
        color: '#FFFFFF',
        '&:hover': {
            opacity: '.5'
        }
    },
    enlacesCentro: {
        display: 'flex',
        justifyContent: 'center',
        '@media screen and (max-width: 959px)': {
            flexDirection: 'column',
            alignItems: 'center'
        }
    },
    enlaceDerecha: {
        display: 'flex',
        justifyContent: 'flex-end',
        height: 0,
        '@media screen and (max-width: 959px)': {
            height: 'inherit',
            justifyContent: 'center'
        },
        '& :first-child': {
            position: 'relative',
            bottom: 16,
            '@media screen and (max-width: 959px)': {
                bottom: 0    
            }
        }
    },
    divider: {
        width: 1,
        backgroundColor: '#FFFFFF',
        margin: '0 5px'
    }
});

export const Footer = (props:any) => {
    // const {ciaGestiona} = React.useContext(PortalContext)
    let cia = props.cia?? (esGestiona()?  'gestiona' : getCiaFromUrl());
    const clases = useStyles();

    return(
        <div className={clases.footerContainer}>
            {cia !== null && datos[cia] ?
                <React.Fragment>
                    <div className={clases.enlacesCentro}>
                        <Link to={datos[cia].primerEnlace} className={clases.enlace}>{datos[cia].primerLabel}</Link>
                        {datos[cia].segundoEnlace && <span className={clases.divider}></span> }
                        {datos[cia].segundoEnlace && <Link to={datos[cia].segundoEnlace} className={clases.enlace}>{datos[cia].segundoLabel}</Link>}
                        {cia !== 'PRE' && <span className={clases.divider}></span>}
                        {cia !== 'PRE' && <Link to={datos[cia].cuartoEnlace} className={clases.enlace}>{datos[cia].cuartoLabel}</Link>}
                    </div>
                    <div className={clases.enlaceDerecha}>
                        <Link to={datos[cia].tercerEnlace} target={'_blank'} className={clases.enlace}>Aviso legal</Link>
                    </div>
                </React.Fragment> :
                <div className={clases.enlacesCentro}>
                    <Link to={datos.SCO.primerEnlace} className={clases.enlace}>{datos.SCO.primerLabel}</Link>
                </div>
            }
        </div>
    );
};